import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Nav from './components/Nav';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import ContentPage from './pages/ContentPage';
import Contact from './pages/Contact';
import Wholesale from './pages/Wholesale';
import { FormsProvider } from './context/FormsContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Only scroll to top on non-hash route changes
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname]);
  return null;
}

function AppLayout() {
  return (
    <>
      <Nav />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/wholesale" element={<Wholesale />} />
        <Route path="/:slug" element={<ContentPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <FormsProvider>
        <AppLayout />
      </FormsProvider>
    </BrowserRouter>
  );
}

export default App;
